import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import { Select, MenuItem, FormControl, InputLabel, TextField, Box, ListSubheader } from "@mui/material";
export default function SelectInput({ label = "", value, onChange, onBlur, onClick, errors, touched, options = [], placeholder = "Select...", name, required = false, enableSearch = false, searchPlaceholder = "Search...", className = "form-input-root", displayText, renderValue, sx }) {
    const [searchText, setSearchText] = useState("");
    const filteredOptions = useMemo(() => {
        if (!searchText)
            return options;
        return options.filter((option) => option.label.toLowerCase().includes(searchText.toLowerCase()));
    }, [options, searchText]);
    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };
    return (_jsxs(Box, { children: [_jsxs(FormControl, { fullWidth: true, error: !!(errors && touched), children: [label && (_jsxs(InputLabel, { shrink: true, children: [label, required && _jsx("span", { style: { color: '#f04438' }, children: "*" })] })), _jsxs(Select, { name: name, value: value || "", onChange: onChange, onBlur: onBlur, onClick: onClick, displayEmpty: true, className: className, renderValue: (selected) => {
                            if (renderValue) {
                                return renderValue(selected);
                            }
                            if (displayText) {
                                return displayText;
                            }
                            if (selected === "") {
                                return _jsx("em", { children: placeholder });
                            }
                            const selectedOption = options.find(opt => opt.value === selected);
                            return selectedOption?.label || selected;
                        }, MenuProps: {
                            autoFocus: false,
                            PaperProps: {
                                style: { maxWidth: 200, maxHeight: 300 }
                            }
                        }, onClose: () => setSearchText(""), sx: {
                            '& .MuiSelect-select': {
                                padding: '10px 14px',
                            },
                            ...(sx || {}),
                        }, children: [_jsx(MenuItem, { value: "", disabled: true, children: _jsx("em", { children: placeholder }) }), enableSearch && (_jsx(ListSubheader, { children: _jsx(TextField, { size: "small", autoFocus: true, placeholder: searchPlaceholder, fullWidth: true, value: searchText, onChange: handleSearchChange, onKeyDown: (e) => {
                                        if (e.key !== "Escape") {
                                            e.stopPropagation();
                                        }
                                    }, sx: { mb: 1 } }) })), filteredOptions.length > 0 ? (filteredOptions.map((option) => (_jsx(MenuItem, { value: option.value, children: option.label }, option.value)))) : (_jsx(MenuItem, { disabled: true, children: _jsx("em", { children: "No options found" }) }))] })] }), errors && touched && (_jsx("div", { className: 'error-label', children: _jsx("p", { children: errors }) }))] }));
}
